module.exports = __webpack_public_path__ + "img/lock.84dbd22a.svg";